var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_123",
    "data-name": "Group 123",
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.683,
    height: 67.23,
    viewBox: "0 0 66.683 67.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3306",
    "data-name": "Path 3306",
    d: "M246.684,901.04V883.953a.973.973,0,0,0-.49-.845l-1.458-.833a.959.959,0,0,0-.915-.024,31.506,31.506,0,0,0-3.176-6.611.965.965,0,0,0,.249-.461l.382-1.679a.974.974,0,0,0-.26-.9l-7.268-7.268a.972.972,0,0,0-.944-.251l-1.62.442a.955.955,0,0,0-.416.239,31.579,31.579,0,0,0-3.138-1.746.957.957,0,0,0-.041-.231l-.507-1.646a.976.976,0,0,0-.679-.653l-4.666-1.25a.972.972,0,0,0-.943.255l-.938.947a31.817,31.817,0,0,0-3.826-.5.961.961,0,0,0-.289-.914l-1.263-1.171a.973.973,0,0,0-.913-.227l-16.505,4.423a.97.97,0,0,0-.689.692l-.427,1.625a.954.954,0,0,0,.216.892,31.882,31.882,0,0,0-6.947,6.371.958.958,0,0,0-.915-.287l-1.683.363a.972.972,0,0,0-.71.618l-5.845,16.056a.975.975,0,0,0,.172.962l1.085,1.282a.96.96,0,0,0,.861.335c0,.194-.007.389-.007.584a31.539,31.539,0,0,0,5.748,18.2l-.308,1.351a.974.974,0,0,0,.261.9l7.268,7.268a.971.971,0,0,0,.944.251l1.62-.442a.992.992,0,0,0,.264-.118,31.463,31.463,0,0,0,11.248,3.926c0,.009.009.018.014.026l.916,1.458a.974.974,0,0,0,.824.455H215.8a.973.973,0,0,0,.845-.49l.752-1.316a31.523,31.523,0,0,0,7.836-1.9.959.959,0,0,0,.646.7l1.639.528a.975.975,0,0,0,.924-.181l13.089-10.983a.972.972,0,0,0,.332-.919l-.3-1.652a.958.958,0,0,0-.573-.718,31.53,31.53,0,0,0,2.829-6.057.96.96,0,0,0,.95-.046l1.458-.916A.975.975,0,0,0,246.684,901.04Zm-2.61-8.495a30.051,30.051,0,1,1-30.051-30.051A30.051,30.051,0,0,1,244.074,892.545Z",
    transform: "translate(-180 -858.589)",
    fill: "#ffdd15"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 6.76,
    cy: 6.76,
    r: 6.76,
    transform: "translate(27.271 27.278)",
    fill: "#ffdd15"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.f6a52858a36d8d7d4e7a59acf9496f6f.svg";
export { ForwardRef as ReactComponent };